import { FetchBusinessProductByLocationIdResponse, ICreateProductPayload, ILocationId } from '@gohighlevel/ghl-proposals-common'

import config from '@/config'
import { requests } from '@/service'

const DEFAULT_PAGE_SIZE = 20

export const ProductService = {
  fetchProductListByLocationId: (params: ILocationId & { limit?: number; offset?: number }) => {
    const { limit = DEFAULT_PAGE_SIZE, offset = 0, ...rest } = params
    return requests(config.PRODUCT_SERVICE_URL).get<FetchBusinessProductByLocationIdResponse>('/', {
      params: {
        ...rest,
        limit,
        offset,
      },
    })
  },

  createNewProduct: (params: ICreateProductPayload) => {
    return requests(config.PRODUCT_SERVICE_URL).post('/', params)
  },

  fetchProductById: (productId: string, locationId: string) => {
    return requests(config.PRODUCT_SERVICE_URL).get(`/${productId}?locationId=${locationId}`)
  },
}
